export default {
  MuiAccordionDetails: {
    root: {
      padding: 0,
      display: 'block',
    },
  },
};
